





































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import Resource from "@/store/entities/resource";
import url from "@/lib/url";
//import ewebeditor from "@/components/ewebeditor.vue";

@Component({
  components: {},
})
export default class EditHiResource extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  resource: Resource = new Resource();
  loadings: boolean = false;
  agreement: boolean = false;
  formTitle: string = "资源发布";
  editorContentConfig: any = {
    style: "coolblue",
    width: "100%",
    height: "350px",
  };
  frontendurl: string = "https://manage.sxjy.cq.cn/dist/ewebeditor/";
  editorBackendurl: string = "https://manage.sxjy.cq.cn/dist/ewebeditor/";
  isCreate: boolean = true;
  data: any = [];
  valueArray: any = [];
  categoryId: number = 0;
  category: number = 0;
  parentId?: number;
  gradeType: number = 1;
  parentName: string = "一级分类";
  topicData: any = [];
  topicOne: any = [];
  topicTwo: any = [];
  uploadActin: string = url + "api/services/app/File/FileAttenGetToken";
  token: string = "Bearer " + window.abp.auth.getToken();
  uploadList: any = [];
  uploadPdfList: any = [];
  attachmentFiles: any = [
    {
      code: 0,
      details: null,
      fileName: "",
      fileToken: "",
      fileType: "",
      message: null,
      pictureBase64: null,
      validationErrors: null,
    },
  ];
  content: string = "";
  fileurl: string = "";
  dataResource: any = [];
  valueResource: any = [];
  readingPoints: number = 0;
  screenWidth: number = document.body.clientWidth - 200;
  mobilescreenWidth: string = "100%";
  setEditorData() {
    (this.$refs["ewe"] as any).setHtmleweb(this.content);
  }

  contentFormSelect(name) {
    this.resource.contentForm = name;
  }
  uploadSuccess(res, file, fileList) {
    if (res.result.fileToken) {
      this.uploadList = fileList;
      if (this.uploadList) {
        setTimeout(() => {
          this.agreement = false;
        }, 1000);
      }
    }
  }
  handleBeforeUpload() {
    this.agreement = true;
  }
  delattfile() {
    this.attachmentFiles = [
      {
        code: 0,
        details: null,
        fileName: "",
        fileToken: "",
        fileType: "",
        message: null,
        pictureBase64: null,
        validationErrors: null,
      },
    ];
    this.resource.attachment = "";
    this.resource.attachmentPaths = [];
    this.resource.attachmentPath = "";
  }
  handleRemove(file, fileList) {
    this.uploadList = fileList;
  }
  handleMaxSize(file) {
    this.$Notice.warning({
      title: "超出文件大小限制",
      desc: "文件【" + file.name + "】 太大, 不能超过900M.",
    });
  }
  cascaderSelect(value, selectedData) {
    if (selectedData.length > 0) {
      this.resource.categoryId = selectedData[selectedData.length - 1].id;
      this.categoryId = selectedData[selectedData.length - 1].id;
    } else this.resource.categoryId = null;
  }
  resourceSelect(value, selectedData) {
    if (selectedData.length > 0) {
      this.resource.resourceCategoryId =
        selectedData[selectedData.length - 1].id;
      this.category = selectedData[selectedData.length - 1].id;
    } else this.resource.resourceCategoryId = null;
  }
  topicOneSelect(value, selectedData) {
    if (selectedData.length > 0)
      this.resource.topicOneId = selectedData[selectedData.length - 1].value;
    else this.resource.topicOneId = null;
  }
  topicTwoSelect(value, selectedData) {
    if (selectedData.length > 0)
      this.resource.topicTwoId = selectedData[selectedData.length - 1].value;
    else this.resource.topicTwoId = null;
  }
  save() {
    this.loadings = true;
    this.resource.gradeType = 1;
    (this.$refs.resourceForm as any).validate(async (valid: boolean) => {
      if (valid) {
        if (this.uploadList && this.uploadList.length > 0) {
          let file = this.uploadList[0].response.result;
          this.resource.attachmentFiles = [
            {
              code: file.code,
              details: file.details,
              fileName: file.fileName,
              fileToken: file.fileToken,
              fileType: file.fileType,
              message: file.message,
              pictureBase64: file.pictureBase64,
              validationErrors: file.validationErrors,
            },
          ];
        }
        if (this.fileurl) {
          this.resource.attachmentFiles = [
            {
              code: 0,
              details: null,
              fileName: this.fileurl,
              fileToken: "",
              fileType: "",
              message: null,
              pictureBase64: null,
              validationErrors: null,
            },
          ];
        }
        this.resource.readingPoints = this.readingPoints;
        this.resource.content = (this.$refs["ewe"] as any).getHtmleweb();

        if (this.valueArray.length > 0) {
          if (this.valueArray.length < 3) {
            this.$Message.warning("分类未选择到末级!");
            this.loadings = false;
            return false;
          }
        } else {
          this.$Message.warning("请选择资源分类");
          this.loadings = false;
          return false;
        }

        if (!this.resource.title) {
          this.$Message.warning("请填写资源标题");
          this.loadings = false;
          return false;
        }
        //  if (!this.resource.issued) {
        //  this.$Message.warning("请填写资源来源");
        //  this.loadings = false;
        //  return false;
        // }
        /**
        if (!this.resource.author) {
          this.$Message.warning("请填写资源作者");
          return false;
        }
        **/

        if (!this.category) {
          this.$Message.error("请选择资源类型!");
          this.loadings = false;
          return false;
        }

        if (!this.resource.content) {
          this.$Message.error("请填写资源内容!");
          this.loadings = false;
          return false;
        }
        /**
        if (!this.categoryId) {
          this.$Message.error("请选择资源目录!");
          return false;
        } else if (!this.category) {
          this.$Message.error("请选择资源类型!");
          return false;
        } else if (!this.resource.content) {
          this.$Message.error("请填写资源内容!");
          return false;
        }
        **/
        // console.log(this.resource);
        let sendType = "resource/update";

        if (this.isCreate) {
          sendType = "resource/create";
        }
        await this.$store
          .dispatch({
            type: sendType,
            data: this.resource,
          })
          .then((result) => {
            this.loadings = false;
            this.resource.attachmentFiles = [
              {
                code: 0,
                details: null,
                fileName: "",
                fileToken: "",
                fileType: "",
                message: null,
                pictureBase64: null,
                validationErrors: null,
              },
            ];
            this.uploadList = [];
          })
          .catch((result) => {
            this.loadings = false;
          });
        if (this.isCreate) {
          (this.$refs["ewe"] as any).setHtmleweb("");
          this.resource.title = "";
          this.resource.description = "";
          // this.readingPoints = 0;
          this.resource.isRecommend = false;
          //this.resource.author = "";
          // this.resource.issued = "";
          this.attachmentFiles = [
            {
              code: 0,
              details: null,
              fileName: "",
              fileToken: "",
              fileType: "",
              message: null,
              pictureBase64: null,
              validationErrors: null,
            },
          ];
          this.uploadList = [];
          this.fileurl = "";
          (this.$refs.upload as any).clearFiles();
        } else {
          this.fileurl = "";
          (this.$refs.resourceForm as any).resetFields();
          this.$emit("save-success");
          this.$emit("input", false);
        }
      }
    });
  }
  cancel() {
    this.visibleChange(false);
  }
  visibleChange(value: boolean) {
    this.data = this.$store.state.resource.cascaders.items;
    this.topicData = this.$store.state.resource.topicCascaders.items;
    this.dataResource = this.$store.state.resource.resourceCascaders.items;
    if (!value) {
      this.resource = new Resource();
      this.$store.state.resource.editResource = this.resource;
      this.valueResource = [];
      this.attachmentFiles = [
        {
          code: 0,
          details: null,
          fileName: "",
          fileToken: "",
          fileType: "",
          message: null,
          pictureBase64: null,
          validationErrors: null,
        },
      ];
      this.fileurl = "";
      this.uploadList = [];
      (this.$refs.resourceForm as any).resetFields();
      (this.$refs.upload as any).clearFiles();
      if (this.isCreate) this.$emit("save-success");
      this.$emit("input", value);
    } else {
      this.resource = Util.extend(
        true,
        {},
        this.$store.state.resource.editResource,
      );
      if (this.resource.id) {
        this.isCreate = false;
        this.formTitle = "资源修改";
        this.categoryId = this.$store.state.resource.editResource.categoryId;
        this.category = this.$store.state.resource.editResource.resourceCategoryId;
        this.content = this.$store.state.resource.editResource.content;
        this.valueArray = this.$store.state.resource.editResource.categoryList;
        this.topicOne = this.$store.state.resource.editResource.topicOneList;
        this.topicTwo = this.$store.state.resource.editResource.topicTwoList;
        this.readingPoints = this.resource.readingPoints;
        this.valueResource.push(this.resource.resourceCategoryId);
        //  this.uploadList = this.setEditorData();
      } else {
        this.isCreate = true;
        this.valueArray = [];
        this.readingPoints = 0;
        this.formTitle = "资源发布";

        // (this.$refs["ewe"] as any).setHtmleweb("");
      }
    }
  }
  validateNameList = (rule, value, callback) => {
    if (value.length === 0) {
      callback(new Error("请选择name"));
    } else {
      callback();
    }
  };
  resourceRule = {};
}
// 校验输入的字符长度
function lenValid(str, num, cb) {
  if (str) {
    let len = str.length;
    if (len > num) {
      return cb(new Error("Too Long..."));
    }
  }
  cb();
}
